import { State } from '../state';

export const unsettledDocuments: State = {
    url: 'unsettled-documents/service'
};
